<template>
  <div>
    <div v-if="locationObject.city" id='map' style="height: 250px; width: 100%;"></div>
    <!-- {{ accessLevel }} -->
  </div>
</template>

<script>
  import gmapsInit from '../../utils/gmaps';

  export default {
    props: ['locationObject', 'accessLevel'],
    data() {
      return {
        // google: null,
      }
    },

    // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
    async mounted() {
      console.log('ran')
      // console.log(this.user)
      // var mapExists = document.getElementById("map");
      // if (mapExists) {
      if (this.locationObject.city) {
        console.log(this.locationObject.city)
        try { // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
          const google = await gmapsInit();
          const geocoder = new google.maps.Geocoder();
          // const map = new google.maps.Map(document.getElementById('map'), {
          //   // zoom: 12,
          //   zoom: 3,
          //   // center: {lat: 52.520, lng: 13.410}
          //   center: {lat: 15.0, lng: 0.0}
          // });
          const map = new google.maps.Map(document.getElementById('map'),
            {
              zoom: 13,
            }
          );

          // geocoder.geocode({ address: 'Austria' }, (results, status) => {

          geocoder.geocode({ address: this.locationObject.address1 + ', ' + this.locationObject.city + ', ' + this.locationObject.country }, (results, status) => {
            if (status !== 'OK' || !results[0]) {
              console.log('Error with geoencoder')
              throw new Error(status);
            }

            map.setCenter(results[0].geometry.location);
            // map.fitBounds(results[0].geometry.viewport);
          });

          // var marker = new google.maps.Marker({
          //       // position: results[0].geometry.location,
          //       position: new google.maps.LatLng(49.884017, -97.168579),
          //       // label: labels[i % labels.length]
          //       // icon: jobListing.icon,
          //       // title: 'test'
          //       map: map
          //     });

          // https://developers.google.com/maps/documentation/geocoding/intro
          // https://developers.google.com/maps/faq#geocoder_queryformat
          // if (this.locationObject.address1 && this.locationObject.city && this.locationObject.country) {
          if (this.accessLevel == 'full') {
            console.log('Trying marker')
            geocoder.geocode({ address: this.locationObject.address1 + ', ' + this.locationObject.city + ', ' + this.locationObject.country }, (results, status) => {
              if (status !== 'OK' || !results[0]) {
                console.log('Error with address geoencoder')
                throw new Error(status);
              }
              else {
                console.log('Got marker')
                console.log(results[0].geometry.location)
              }

              var marker = new google.maps.Marker({
                position: results[0].geometry.location,
                // position: new google.maps.LatLng(49.884017, -97.168579),
                // label: labels[i % labels.length]
                // icon: jobListing.icon,
                // title: 'test'
                map: map
              });
            });
          }

        } catch (error) {
          console.log('Error with map')
          console.error(error);
        }
      }
      // }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/global/Map.vue